export default __webpack_public_path__ + "static/media/diabetes.2e68d6fd.svg";